import React, { useEffect, useState } from 'react';
import { validateFunctionalForm } from '../../../utils';
import { v2_user_by_designations } from '../../../actions/v2/user';
import constant from '../../../constant';
import { v2_companies, v2_shipyards } from '../../../actions/v2/masterData';

const ShipForm = ({ data, onSubmit, title }) => {
    const [state, setState] = useState({
        projectName: { name: 'projectName', value: data?.PROJECT_NAME || '', isRequired: true, error: '' },
        projectCode: { name: 'projectCode', value: data?.PROJECT_CODE || '', isRequired: false, error: '' },
        company: { name: 'company', value: data?.COMPANY_ID || '', options: [], isRequired: true, error: '' },
        shipyard: { name: 'shipyard', value: data?.SHIPYARD_ID || '', options: [], isRequired: true, error: '' },
        projectManager: { name: 'projectManager', value: data?.PROJECT_MANAGER_ID || '', options: [], isRequired: false, error: '' },
        startDate: { name: 'startDate', value: data?.START_DATE || '', isRequired: true, error: '' },
        endDate: { name: 'endDate', value: data?.END_DATE || '', isRequired: false, error: '' },
        isActive: { name: 'isActive', value: data?.IS_ACTIVE ?? true, isRequired: false },
        note: { name: 'note', value: data?.DESCRIPTION || '', isRequired: false, error: '' },
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        const val = type === 'checkbox' ? checked : value;
        setState(prev => ({
            ...prev,
            [name]: {
                ...prev[name],
                value: val,
                error: prev[name].isRequired && !val ? 'This field is required' : ''
            }
        }));
    };

    useEffect(() => {
        v2_user_by_designations(3).then((res) => {
            if (res.status) {
                setState(prev => ({
                    ...prev,
                    ['projectManager']: {
                        ...prev['projectManager'],
                        options: res.result,
                    }
                }));
            }
        })

        v2_companies().then((res) => {
            if (res.status) {
                setState(prev => ({
                    ...prev,
                    ['company']: {
                        ...prev['company'],
                        options: res.result,
                    }
                }));
            }
        })
        v2_shipyards().then((res) => {
            if (res.status) {
                setState(prev => ({
                    ...prev,
                    ['shipyard']: {
                        ...prev['shipyard'],
                        options: res.result,
                    }
                }));
            }
        })
    }, [])

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateFunctionalForm(state, setState)) {
            const model = {};
            Object.keys(state).forEach(key => {
                model[key] = state[key].value;
            });
            if (data?.ID) model.id = data.ID;
            onSubmit(model);
        }
    };

    const handleReset = () => {
        const resetState = { ...state };
        Object.keys(resetState).forEach(key => {
            resetState[key].value = data?.[key.toUpperCase()] || (key === 'isActive' ? true : '');
            resetState[key].error = '';
        });
        setState(resetState);
    };

    return (
        <form onSubmit={handleSubmit}>
            {/* <h4 className="card-title mb-4">{title}</h4> */}
            <div className="row">
                <div className="col-md-6 mb-3">
                    <label>Project Name {state.projectName.isRequired && <span className='text-danger'>*</span>}</label>
                    <input
                        type="text"
                        name={state.projectName.name}
                        value={state.projectName.value}
                        onChange={handleChange}
                        placeholder="Enter project"
                        className={`form-control ${state.projectName.error ? 'is-invalid' : ''}`}
                    />
                    {state.projectName.error && <div className="invalid-feedback">{state.projectName.error}</div>}
                </div>

                <div className="col-md-6 mb-3">
                    <label>Project Code {state.projectCode.isRequired && <span className='text-danger'>*</span>}</label>
                    <input
                        type="text"
                        name={state.projectCode.name}
                        value={state.projectCode.value}
                        onChange={handleChange}
                        placeholder="Enter unique project code"
                        className={`form-control ${state.projectCode.error ? 'is-invalid' : ''}`}
                    />
                    {state.projectCode.error && <div className="invalid-feedback">{state.projectCode.error}</div>}
                </div>
                <div className="col-md-6 mb-3">
                    <label>Company {state.company.isRequired && <span className='text-danger'>*</span>}</label>
                    <select
                        name={state.company.name}
                        value={state.company.value}
                        onChange={handleChange}
                        className={`form-select ${state.company.error ? 'is-invalid' : ''}`}
                    >
                        <option value={''}>Select Company</option>
                        {state.company.options.map((item) => {
                            return (<option value={item.ID}>{item.COMPANY_NAME}</option>)
                        })}
                    </select>
                    {state.company.error && <div className="invalid-feedback">{state.company.error}</div>}
                </div>

                <div className="col-md-6 mb-3">
                    <label>Shipyard {state.shipyard.isRequired && <span className='text-danger'>*</span>}</label>
                    <select
                        name={state.shipyard.name}
                        value={state.shipyard.value}
                        onChange={handleChange}
                        className={`form-select ${state.shipyard.error ? 'is-invalid' : ''}`}
                    >
                        <option value={''}>Select Shipyard</option>
                        {state.shipyard.options.map((item) => {
                            return (<option value={item.ID}>{item.SHIPYARD_NAME}</option>)
                        })}
                    </select>
                    {state.shipyard.error && <div className="invalid-feedback">{state.shipyard.error}</div>}
                </div>

                <div className="col-md-6 mb-3">
                    <label>Project Manager {state.projectManager.isRequired && <span className='text-danger'>*</span>}</label>
                    <select
                        name={state.projectManager.name}
                        value={state.projectManager.value}
                        onChange={handleChange}
                        placeholder="Enter unique project code"
                        className={`form-select ${state.projectManager.error ? 'is-invalid' : ''}`}
                    >
                        <option value={''}>Select Project Manager</option>
                        {state.projectManager.options.map((item) => {
                            return (<option value={item.USER_ID}>{item.FULL_NAME}</option>)
                        })}
                    </select>
                    {state.projectManager.error && <div className="invalid-feedback">{state.projectManager.error}</div>}
                </div>

                <div className="col-md-3 mb-3">
                    <label>Start Date {state.startDate.isRequired&& <span className='text-danger'>*</span>}</label>
                    <input
                        type="date"
                        name={state.startDate.name}
                        value={state.startDate.value}
                        onChange={handleChange}
                        className={`form-control ${state.startDate.error ? 'is-invalid' : ''}`}
                    />
                    {state.startDate.error && <div className="invalid-feedback">{state.startDate.error}</div>}
                </div>
                <div className="col-md-3 mb-3">
                    <label>End Date {state.endDate.isRequired && <span className='text-danger'>*</span>}</label>
                    <input
                        type="date"
                        name={state.endDate.name}
                        value={state.endDate.value}
                        onChange={handleChange}
                        className={`form-control ${state.endDate.error ? 'is-invalid' : ''}`}
                    />
                    {state.endDate.error && <div className="invalid-feedback">{state.endDate.error}</div>}
                </div>

                <div className="col-md-12 mb-3">
                    <label>Description {state.note.isRequired && <span className='text-danger'>*</span>}</label>
                    <textarea
                        name={state.note.name}
                        value={state.note.value}
                        onChange={handleChange}
                        className="form-control"
                        rows="3"
                        placeholder="Enter project description here"
                    />
                </div>

                <div className="col-md-4 form-check ms-2">
                    <input
                        type="checkbox"
                        name={state.isActive.name}
                        checked={state.isActive.value}
                        onChange={handleChange}
                        className="form-check-input"
                        id="isActive"
                    />
                    <label className="form-check-label" htmlFor="isActive">Active</label>
                </div>
            </div>

            <div className="mt-3">
                <button type="submit" className="btn btn-success me-2">Save</button>
                <a className="btn btn-danger text-white" href={constant.Authedcomponent.listProject.url}>Cancel</a>

            </div>
        </form >
    );
};

export default ShipForm;
